import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSalesmanCustomerList,
  ValidateandAcumlateQRCodes,
  giftRedeemQRCode,
  updateCustomer,
} from "../../redux/actions/salesmanAction";
import {
  fetchCustomerTypes,
  fetchKarnatakaCities,
} from "../../redux/actions/customerActions";
import { DashboardLayout } from "../../Pages/dashboard/DashboardLayout";
import { useNavigate } from "react-router-dom";
import {
  FaUser,
  FaArrowLeft,
  FaQrcode,
  FaGift,
  FaPhoneAlt,
} from "react-icons/fa";
import SearchBar from "../../Pages/Components/SearchBar";
import SortableTable from "../../Pages/Components/SortableTable";
import AccumulationResultModal from "../../Pages/SalesMan/AccumulationResultModal";
import RedeemGiftModal from "../../Pages/SalesMan/RedeemGiftModal";
import "react-datepicker/dist/react-datepicker.css";
import { LoadScriptNext, Autocomplete } from "@react-google-maps/api";
import { FiDownload } from "react-icons/fi";
import { FaMapMarkerAlt } from "react-icons/fa";
import CitySingleSelectDropdown from "../../Pages/Components/CitySingleSelectDropdown";
const CustomerList = () => {
  const dispatch = useDispatch();
  const { loading, customers, error } = useSelector((state) => state.salesman);
  const { userInfo } = useSelector((state) => state.auth);
  const { customerTypes = [] } = useSelector(
    (state) => state.fetchCustomerList || {},
  );
  const { karnatakaCities = [], citiesLoading = false } = useSelector(
    (state) => state.fetchCustomerList || {},
  );
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const token = userInfo?.access_token;
  const [cityFilter, setCityFilter] = useState("");
  // Get role_id to determine if we should show list by default
  // Check both userInfo and dashboardData for role_id
  const dashboardData = useSelector((state) => state.dashboard?.data);
  const roleId = dashboardData?.role_id || userInfo?.role_id;
  const isDealer = String(roleId) === "1";
  const isSalesman = String(roleId) === "2";

  // Modal states - matching salesmanQRscan.jsx
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [accumulationResult, setAccumulationResult] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [isSubmittingRedeem, setIsSubmittingRedeem] = useState(false);

  // Store current customer data and gift ID for redemption
  const [currentCustomerData, setCurrentCustomerData] = useState(null);
  const [redeemingGiftId, setRedeemingGiftId] = useState(null);
  const orderType = dashboardData?.user_order_type || userInfo?.user_order_type;
  const isCustomerPromotional = orderType === "promotional";

  // Edit customer modal state (only for role 1 dealer)
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [editForm, setEditForm] = useState({
    name: "",
    mobile: "",
    email: "",
    city: "",
    state: "",
    pincode: "",
    firm_name: "",
    address: "",
    customer_type: "",
    customer_code: "",
    customer_grade: "A",
    lat: "",
    long: "",
  });

  // GPS / autocomplete state for edit modal (mirrors CreateCustomer.jsx)
  const editAutocompleteRef = useRef(null);
  const [editIsAddressFetched, setEditIsAddressFetched] = useState(false);
  const [editDisableCity, setEditDisableCity] = useState(false);
  const [editDisableState, setEditDisableState] = useState(false);
  const [editDisablePincode, setEditDisablePincode] = useState(false);
  const [editCityDropdownOpen, setEditCityDropdownOpen] = useState(false);
  const editCityDropdownRef = useRef(null);

  // Close the custom city dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        editCityDropdownRef.current &&
        !editCityDropdownRef.current.contains(e.target)
      ) {
        setEditCityDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleEditPlaceChanged = () => {
    if (!editAutocompleteRef.current) return;
    const place = editAutocompleteRef.current?.getPlace();
    if (!place) return;

    let address = "";
    let city = "";
    let state = "";
    let pincode = "";
    let lat = "";
    let long = "";

    if (place.geometry && place.geometry.location) {
      lat = place.geometry.location.lat().toString();
      long = place.geometry.location.lng().toString();
    }

    place.address_components?.forEach((component) => {
      const types = component.types;
      if (types.includes("locality")) {
        city = component.long_name;
      }
      if (types.includes("administrative_area_level_1")) {
        state = component.long_name;
      }
      if (types.includes("postal_code")) {
        pincode = component.long_name;
      }
    });

    address = place.formatted_address || "";

    setEditForm((prev) => ({
      ...prev,
      address,
      city,
      state,
      pincode,
      lat,
      long,
    }));
    setEditDisableCity(city !== "");
    setEditDisableState(state !== "");
    setEditDisablePincode(pincode !== "");
  };

  // useEffect(() => {
  //   if (userInfo?.access_token) {
  //     dispatch(fetchSalesmanCustomerList(userInfo.access_token));
  //     // Fetch customer types so dealer can change customer type on edit
  //     dispatch(fetchCustomerTypes(userInfo.access_token));
  //     dispatch(fetchKarnatakaCities(userInfo.access_token));
  //   }
  // }, [dispatch, userInfo?.access_token]);

  // One-time lookups — customer types and the city list don't depend on the filter
  useEffect(() => {
    if (userInfo?.access_token) {
      dispatch(fetchCustomerTypes(userInfo.access_token));
      dispatch(fetchKarnatakaCities(userInfo.access_token));
    }
  }, [dispatch, userInfo?.access_token]);

  // Re-fetch the customer list whenever the city filter changes
  useEffect(() => {
    if (userInfo?.access_token) {
      dispatch(
        fetchSalesmanCustomerList(
          userInfo.access_token,
          cityFilter ? { city: cityFilter } : undefined,
        ),
      );
    }
  }, [dispatch, userInfo?.access_token, cityFilter]);

  // if (error) return <p>Error: {error}</p>;

  const getErrorMessage = (errorObj) => {
    if (!errorObj) return "Unknown error occurred";
    if (typeof errorObj === "string") return errorObj;
    if (typeof errorObj === "object") {
      return (
        errorObj?.detailed_message ||
        errorObj?.message ||
        errorObj?.error ||
        JSON.stringify(errorObj)
      );
    }
    return "An error occurred";
  };

  if (error) {
    const errorMessage = getErrorMessage(error);
    return (
      <DashboardLayout>
        <div className="text-center py-8">
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded max-w-md mx-auto">
            <p className="font-bold text-lg mb-2">⚠️ Error Loading Customers</p>
            <p className="text-sm">{errorMessage}</p>
            <button
              onClick={() => {
                if (userInfo?.access_token) {
                  dispatch(fetchSalesmanCustomerList(userInfo.access_token));
                }
              }}
              className="mt-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded transition"
            >
              Retry
            </button>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  // Convert single customer object to array if needed
  const customerArray = Array.isArray(customers)
    ? customers
    : customers
      ? [customers]
      : [];

  // For dealers (role 1), show all customers when search is empty
  // For other roles, require a search term
  const filteredCustomers = (() => {
    // If dealer and search is empty, return all customers
    if (isDealer && searchValue === "") {
      return customerArray;
    }

    // If not dealer and search is empty, return empty array
    if (!isDealer && searchValue === "") {
      return [];
    }

    // Apply search filter when there's a search term
    const search = searchValue.toLowerCase();
    return customerArray.filter((customer) => {
      const name = customer.name?.toLowerCase() || "";
      const mobile = customer.mobile?.toLowerCase() || "";
      const customerCode = (customer.customer_code || "").toLowerCase();
      const city = customer.city?.toLowerCase() || "";

      return (
        name.includes(search) ||
        mobile.includes(search) ||
        customerCode.includes(search) ||
        city.includes(search)
      );
    });
  })();

  // Debug log to verify role detection and data
  console.log(
    "CustomerList - roleId:",
    roleId,
    "isDealer:",
    isDealer,
    "searchValue:",
    searchValue,
    "customers count:",
    customerArray.length,
    "filtered count:",
    filteredCustomers.length,
  );

  // Handle Redeem button click - fetches customer's accumulated gifts
  const handleRedeemClick = async (customer) => {
    setIsValidating(true);
    setCurrentCustomerData(customer);

    try {
      const result = await dispatch(
        ValidateandAcumlateQRCodes(
          {
            qr_ids: [],
            customer_id: customer.customer_id,
          },
          userInfo.access_token,
        ),
      );

      console.log("Customer Accumulated Gifts Result:", result);

      if (result?.type === "REDEEM_QR_SUCCESS" || result?.payload) {
        const resultData = result.payload || result;
        setAccumulationResult(resultData);
        setShowResultModal(true);
      } else {
        const errorMsg =
          result?.payload?.message || "Failed to fetch gift data";
        alert(`✗ Error: ${errorMsg}`);
      }
    } catch (err) {
      console.error("Error fetching customer gifts:", err);
      alert(
        err.response?.data?.message ||
          err.message ||
          "Failed to fetch customer gift data",
      );
    } finally {
      setIsValidating(false);
    }
  };

  // Handle gift redemption - opens RedeemGiftModal
  const handleRedeemGift = (giftId) => {
    console.log("Redeeming gift:", giftId);
    setRedeemingGiftId(giftId);
    setShowRedeemModal(true);
  };

  // Submit redemption with signature and selfie
  const handleSubmitRedeem = async (data) => {
    const { signature, selfie } = data;

    if (!signature) {
      alert("Please provide a signature");
      return;
    }
    if (!selfie) {
      alert("Please provide a selfie/photo");
      return;
    }

    const confirmed = window.confirm(
      "Confirm gift redemption with signature and selfie?",
    );
    if (!confirmed) return;

    setIsSubmittingRedeem(true);

    try {
      const qrIds = accumulationResult?.qr_ids || [];
      const customerId = currentCustomerData?.customer_id;

      let lat = "0";
      let long = "0";

      // Get geolocation
      if (navigator.geolocation) {
        await new Promise((resolve) => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              lat = position.coords.latitude.toString();
              long = position.coords.longitude.toString();
              resolve();
            },
            (error) => {
              console.log("Geolocation error:", error);
              resolve();
            },
          );
        });
      }

      const address =
        currentCustomerData?.address ||
        currentCustomerData?.firm_name ||
        "Not provided";
      const city = currentCustomerData?.city || "Not provided";
      const state = currentCustomerData?.state || "Not provided";
      const pincode = currentCustomerData?.pincode || "Not provided";

      const payload = {
        // qr_ids: qrIds,
        ...(isCustomerPromotional ? {} : { qr_ids: qrIds }),
        customer_id: customerId,
        gift_id: redeemingGiftId,
        customer_sign: signature,
        customer_selfie: selfie,
        address: address,
        city: city,
        state: state,
        pincode: pincode,
        lat: lat,
        long: long,
      };

      console.log("Redeem Payload:", {
        ...payload,
        customer_sign: payload.customer_sign.substring(0, 50) + "...",
        customer_selfie: payload.customer_selfie.substring(0, 50) + "...",
      });

      const result = await dispatch(giftRedeemQRCode(payload, token));

      if (
        result?.type === "GIFT_REDEEM_QR_SUCCESS" ||
        result?.payload?.status === 200
      ) {
        alert("✓ Gift redeemed successfully!");
        setShowRedeemModal(false);
        setRedeemingGiftId(null);
        setShowResultModal(false);
        setCurrentCustomerData(null);
        // Refresh customer list
        dispatch(fetchSalesmanCustomerList(userInfo.access_token));
      } else {
        const errorMsg = result?.payload?.message || "Gift redemption failed";
        alert(`✗ Error: ${errorMsg}`);
      }
    } catch (error) {
      console.error("Redemption error:", error);
      alert(`✗ Failed to redeem gift: ${error.message}`);
    } finally {
      setIsSubmittingRedeem(false);
    }
  };

  const handleCloseResultModal = () => {
    setShowResultModal(false);
    setAccumulationResult(null);
    setCurrentCustomerData(null);
  };

  const handleScanMore = () => {
    setShowResultModal(false);
    // Navigate to QR scan page with current customer data
    if (currentCustomerData) {
      navigate(`/dashboard/salesmanconsumerqr`, {
        state: { customerData: currentCustomerData },
        replace: false,
      });
    }
  };

  const columns = [
    { label: "Name", key: "name" },
    // { label: "Customer Type", key: "customer_type" },
    ...(!isCustomerPromotional
      ? [{ label: "Customer Type", key: "customer_type" }]
      : []),
    ...(isCustomerPromotional
      ? [{ label: "Points", key: "total_points_earned" }]
      : []),
    { label: "Customer Id", key: "customer_code" },
    { label: "Grade", key: "customer_grade" },
    { label: "Mobile", key: "mobile" },
    // { label: "Email", key: "email" },
    { label: "Address", key: "address" },
    { label: "City", key: "city" },
    { label: "Created At", key: "created_at" },
    { label: "Actions", key: "actions", sortable: false },
  ];

  const renderRow = (customer) => (
    <tr
      key={customer.customer_code}
      className="hover:bg-blue-50 hover:text-gray-950 hover:font-semibold"
    >
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        {customer.name}
      </td>
      {!isCustomerPromotional && (
        <td className="px-2 py-4 border-b border-gray-400 text-sm">
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            {customer.customer_type?.name || "-"}
          </span>
        </td>
      )}
      {isCustomerPromotional && (
        <td className="px-2 py-4 border-b border-gray-400 text-sm">
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
            {customer.total_points_earned ?? "-"}
          </span>
        </td>
      )}
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        {customer.customer_code}
      </td>
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
          {customer.customer_grade || "-"}
        </span>
      </td>
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        <div className="flex items-center gap-1">
          <span>{customer.mobile || "-"}</span>
          {customer.mobile && (
            <a
              href={`tel:${customer.mobile}`}
              title="Call customer"
              className="text-green-600 hover:text-green-800 ml-1"
            >
              <FaPhoneAlt size={14} />
            </a>
          )}
        </div>
      </td>
      {/* <td className="px-2 py-4 border-b border-gray-400 text-sm">
        {customer.email}
      </td> */}
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        <div className="flex items-center gap-1">
          <span>{customer.address || "-"}</span>
          {customer.address && (
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
                [customer.address, customer.city].filter(Boolean).join(", "),
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Open in Google Maps"
              className="text-red-500 hover:text-red-700 ml-1"
            >
              <FaMapMarkerAlt size={18} />
            </a>
          )}
        </div>
      </td>
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        {customer.city || "-"}
      </td>
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        {customer.created_at}
      </td>
      <td className="px-2 py-4 border-b border-gray-400">
        <div className="flex items-center gap-2 flex-wrap">
          {isSalesman && (
            <>
              <button
                title="Scan QR Codes"
                className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs flex items-center gap-1 whitespace-nowrap"
                onClick={() => {
                  navigate(`/dashboard/salesmanconsumerqr`, {
                    state: { customerData: customer },
                    replace: false,
                  });
                }}
              >
                <FaQrcode /> Scan
              </button>
              <button
                title="Redeem Gifts"
                className={`px-2 py-1 rounded text-xs flex items-center gap-1 whitespace-nowrap ${
                  isValidating
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-500 hover:bg-green-600"
                } text-white`}
                onClick={() => handleRedeemClick(customer)}
                disabled={isValidating}
              >
                <FaGift /> {isValidating ? "Loading..." : "Redeem"}
              </button>
            </>
          )}
          {isDealer && (
            <>
              <button
                title="Edit Customer"
                className="bg-amber-500 hover:bg-amber-600 text-white px-2 py-1 rounded text-xs flex items-center gap-1 whitespace-nowrap"
                onClick={() => {
                  setEditingCustomer(customer);
                  setEditForm({
                    name: customer.name || "",
                    mobile: customer.mobile || "",
                    email: customer.email || "",
                    city: customer.city || "",
                    state: customer.state || "",
                    pincode: customer.pincode || "",
                    firm_name: customer.firm_name || "",
                    address: customer.address || "",
                    customer_type: customer.customer_type?.id || "",
                    customer_code: customer.customer_code || "",
                    customer_grade: customer.customer_grade || "",
                    lat: customer.lat || "",
                    long: customer.long || "",
                  });
                  setEditIsAddressFetched(false);
                  setEditDisableCity(false);
                  setEditDisableState(false);
                  setEditDisablePincode(false);
                  setShowEditModal(true);
                }}
              >
                Edit
              </button>
              {isCustomerPromotional && (
                <button
                  title="View Redeem"
                  className="bg-purple-500 hover:bg-purple-600 text-white px-2 py-1 rounded text-xs flex items-center gap-1 whitespace-nowrap"
                  onClick={() => handleRedeemClick(customer)}
                >
                  <FaGift /> View Redeem
                </button>
              )}
            </>
          )}
        </div>
      </td>
    </tr>
  );

  // Mobile Card View
  const MobileCustomerCard = ({ customer }) => (
    <div className="bg-white border border-gray-300 rounded-lg p-4 mb-4 shadow-sm hover:shadow-md transition">
      <div className="space-y-3">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-xs text-gray-500">Name</p>
            <p className="font-semibold text-gray-900">{customer.name}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Customer Id</p>
            <p className="font-medium text-gray-900 text-sm">
              {customer.customer_code}
            </p>
          </div>
          <div className="flex flex-col items-end gap-1">
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {customer.customer_type?.name || "-"}
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
              Grade: {customer.customer_grade || "-"}
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
       
          <div>
            <p className="text-xs text-gray-500">Mobile</p>
            <div className="flex items-center gap-1">
              <p className="font-medium text-gray-900 text-sm">
                {customer.mobile || "-"}
              </p>
              {customer.mobile && (
                <a
                  href={`tel:${customer.mobile}`}
                  title="Call customer"
                  className="text-green-600 hover:text-green-800"
                >
                  <FaPhoneAlt size={14} />
                </a>
              )}
            </div>
          </div>
          <div>
            <p className="text-xs text-gray-500">Whatsapp Number</p>
            <p className="font-medium text-gray-900 text-sm">
              {customer.alternate_mobile}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <p className="text-xs text-gray-500">City</p>
            <p className="font-medium text-gray-900 text-sm">
              {customer.city || "-"}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Email</p>
            <p className="font-medium text-gray-900 text-sm break-words">
              {customer.email}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <p className="text-xs text-gray-500">Firm</p>
            <p className="font-medium text-gray-900 text-sm">
              {customer.firm_name || "-"}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Created</p>
            <p className="font-medium text-gray-900 text-sm">
              {customer.created_at}
            </p>
          </div>
        </div>
        <div>
          <p className="text-xs text-gray-500">Address</p>
          <div className="flex items-start gap-1">
            <p className="font-medium text-gray-900 text-sm">
              {customer.address || "-"}
            </p>
            {customer.address && (
              <a
                href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
                  [customer.address, customer.city].filter(Boolean).join(", "),
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                title="Open in Google Maps"
                className="text-red-500 hover:text-red-700 ml-1"
              >
                <FaMapMarkerAlt size={18} />
              </a>
            )}
          </div>
        </div>
        <div className="flex gap-2 pt-2 border-t">
          <button
            className="flex-1 bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded text-xs flex items-center justify-center gap-1"
            onClick={() => {
              navigate(`/dashboard/salesmanconsumerqr`, {
                state: { customerData: customer },
                replace: false,
              });
            }}
          >
            <FaQrcode /> Scan
          </button>
          <button
            className={`flex-1 px-3 py-2 rounded text-xs flex items-center justify-center gap-1 ${
              isValidating
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-500 hover:bg-green-600"
            } text-white`}
            onClick={() => handleRedeemClick(customer)}
            disabled={isValidating}
          >
            <FaGift /> {isValidating ? "Loading..." : "Redeem"}
          </button>
          {isDealer && (
            <button
              className="flex-1 bg-amber-500 hover:bg-amber-600 text-white px-3 py-2 rounded text-xs flex items-center justify-center gap-1"
              onClick={() => {
                setEditingCustomer(customer);
                setEditForm({
                  name: customer.name || "",
                  mobile: customer.mobile || "",
                  email: customer.email || "",
                  city: customer.city || "",
                  state: customer.state || "",
                  pincode: customer.pincode || "",
                  firm_name: customer.firm_name || "",
                  address: customer.address || "",
                  customer_type: customer.customer_type?.id || "",
                  customer_code: customer.customer_code || "",
                  customer_grade: customer.customer_grade || "A",
                  lat: customer.lat || "",
                  long: customer.long || "",
                });
                setEditIsAddressFetched(false);
                setEditDisableCity(false);
                setEditDisableState(false);
                setEditDisablePincode(false);
                setShowEditModal(true);
              }}
            >
              Edit
            </button>
          )}
        </div>
      </div>
    </div>
  );
  // Add this helper function at the top level of your component file or in a utils file
  const downloadFile = (fileUrl) => {
    try {
      // Create an anchor element
      const link = document.createElement("a");
      link.href = fileUrl;

      // Extract filename from URL or use default
      const urlParts = fileUrl.split("/");
      const filename = urlParts[urlParts.length - 1] || "Customer_List.xlsx";

      link.setAttribute("download", filename);
      link.setAttribute("target", "_blank");

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      console.log("Download started for:", filename);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download file. Please try again.");
    }
  };

  // Update your handleDownload function
  const handleDownload = async () => {
    try {
      const response = await dispatch(
        fetchSalesmanCustomerList(userInfo.access_token, { download: true }),
      );

      console.log("Download response:", response);

      const fileUrl = response?.payload?.download_url;

      if (fileUrl) {
        downloadFile(fileUrl);
      } else {
        alert("No download URL received from server");
        console.warn("No download_url in response:", response);
      }
    } catch (err) {
      console.error("Download failed:", err);
      alert("Failed to initiate download");
    }
  };
  return (
    <DashboardLayout>
      <div className="mt-2 max-w-full mx-auto rounded-lg p-2 sm:p-4">
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4">
          <div className="flex items-center space-x-3">
            <button
              onClick={() => navigate(-1)}
              className="hover:text-gray-800"
            >
              <FaArrowLeft size={20} />
            </button>

            <h2 className="text-xl sm:text-2xl font-bold text-amber-600">
              Customer List
            </h2>
          </div>

          <div className="flex flex-wrap gap-2 w-full sm:w-auto">
            {/* Export button - only show for role_id === 1 (Dealer) */}
            {isDealer && (
              <button
                onClick={handleDownload}
                className="bg-white flex items-center px-4 py-2 text-sm font-medium text-black border border-gray-500 rounded-md transition hover:bg-gray-50"
              >
                <FiDownload className="w-4 h-4 mr-2 text-amber-500" />
                Export
              </button>
            )}

            <button
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 flex items-center px-4 py-2 text-sm font-medium text-white border border-amber-600 rounded-lg transition shadow-md hover:shadow-lg"
              onClick={() => {
                navigate("/dashboard/createsalesmancustomer");
              }}
            >
              <FaUser className="mr-2" />
              <span className="hidden sm:inline">Add Customer</span>
              <span className="sm:hidden">Add Customer</span>
            </button>
          </div>
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-3 mb-4">
          <SearchBar
            value={searchValue}
            onChange={setSearchValue}
            placeholder="Search by Customer Code / Name /Mobile Number /City"
          />
          {isDealer && (
            <div className="w-full sm:w-56">
              <CitySingleSelectDropdown
                cities={karnatakaCities.map((c) =>
                  typeof c === "string" ? c : c.name,
                )}
                selected={cityFilter}
                loading={citiesLoading}
                placeholder="All Cities"
                onChange={setCityFilter}
              />
            </div>
          )}
          {isDealer && (searchValue || cityFilter.length > 0) && (
            <button
              type="button"
              onClick={() => {
                setSearchValue("");
                setCityFilter([]);
              }}
              className="w-full sm:w-auto border border-gray-300 rounded-md px-4 py-2.5 text-sm font-medium text-gray-600 bg-white hover:bg-gray-50 hover:text-red-600 hover:border-red-300 transition whitespace-nowrap"
            >
              Clear Filters
            </button>
          )}
        </div>

        {/* Content */}
        {loading ? (
          <p className="font-bold text-md text-center text-gray-950 py-6">
            Loading customers...
          </p>
        ) : !isDealer && searchValue === "" ? (
          <p className="font-bold text-md text-center text-gray-950 py-6">
            Enter search term to view customers
          </p>
        ) : filteredCustomers.length === 0 ? (
          <p className="font-bold text-md text-center text-gray-950 py-6">
            {isDealer ? "No customers found" : "No customers found"}
          </p>
        ) : (
          <>
            {/* Mobile View - Cards */}
            <div className="md:hidden">
              {filteredCustomers.map((customer) => (
                <MobileCustomerCard
                  key={customer.customer_id || customer.customer_code}
                  customer={customer}
                />
              ))}
            </div>

            {/* Desktop View - Table */}
            <div className="hidden md:block overflow-x-auto">
              <SortableTable
                columns={columns}
                data={filteredCustomers}
                renderRow={renderRow}
              />
            </div>
          </>
        )}
      </div>

      {/* Modals - Same flow as salesmanQRscan.jsx */}
      <AccumulationResultModal
        showResultModal={showResultModal}
        accumulationResult={accumulationResult}
        isPromotional={isCustomerPromotional}
        onClose={handleCloseResultModal}
        onScanMore={handleScanMore}
        onRedeemGift={handleRedeemGift}
      />

      <RedeemGiftModal
        showRedeemModal={showRedeemModal}
        onClose={() => {
          setShowRedeemModal(false);
          setRedeemingGiftId(null);
        }}
        onSubmit={handleSubmitRedeem}
        isSubmitting={isSubmittingRedeem}
      />

      {/* Edit Customer Modal - only visible for role 1 (Dealer) */}
      {/* {isDealer && showEditModal && editingCustomer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-xl shadow-2xl border border-amber-200 w-full max-w-lg p-6 relative">
            <h3 className="text-lg font-bold text-amber-600 mb-4 text-center">
              Edit Customer
            </h3>
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                if (!editForm.name.trim()) {
                  alert("Name is required");
                  return;
                }
                if (
                  editForm.mobile &&
                  (!/^\d{10}$/.test(editForm.mobile) ||
                    !/^[6-9]/.test(editForm.mobile))
                ) {
                  alert("Please enter a valid 10-digit mobile number");
                  return;
                }

                // Basic email validation if provided
                if (editForm.email) {
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailRegex.test(editForm.email)) {
                    alert("Please enter a valid email address");
                    return;
                  }
                }

                // Double confirmation if customer_code is changed
                const originalCode = editingCustomer.customer_code || "";
                const newCode = (editForm.customer_code || "").trim();
                if (newCode && newCode !== originalCode) {
                  const confirm1 = window.confirm(
                    "You are changing the Customer Code. This may affect reports and existing references.\nAre you sure you want to change it?"
                  );
                  if (!confirm1) return;
                  const confirm2 = window.confirm(
                    `Confirm updating Customer Code from "${originalCode}" to "${newCode}"?`
                  );
                  if (!confirm2) return;
                }

                const payload = {
                  customer_id: editingCustomer.customer_id,
                  name: editForm.name.trim(),
                  mobile: editForm.mobile.trim(),
                  email: editForm.email.trim(),
                  city: editForm.city.trim(),
                   firm_name: editForm.firm_name.trim(),
                   address: editForm.address.trim(),
                   customer_type: editForm.customer_type || undefined,
                   customer_code: editForm.customer_code.trim(),
                };
                const result = await dispatch(
                  updateCustomer(payload, userInfo.access_token)
                );
                if (result.success) {
                  setShowEditModal(false);
                  setEditingCustomer(null);
                  // Refresh list
                  dispatch(fetchSalesmanCustomerList(userInfo.access_token));
                } else {
                  const msg =
                    result.error?.message ||
                    result.error?.detail ||
                    "Failed to update customer";
                  alert(msg);
                }
              }}
              className="space-y-4"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                  <input
                    type="text"
                    value={editForm.name}
                    onChange={(e) =>
                      setEditForm((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                    placeholder=" "
                    required
                  />
                  <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                    peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                    Name
                  </label>
                </div>

                <div className="relative">
                  <input
                    type="text"
                    value={editForm.mobile}
                    onChange={(e) => {
                      const cleaned = e.target.value.replace(/\D/g, "");
                      if (cleaned === "" || cleaned.length <= 10) {
                        setEditForm((prev) => ({
                          ...prev,
                          mobile: cleaned,
                        }));
                      }
                    }}
                    className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                    placeholder=" "
                  />
                  <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                    peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                    Mobile
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                  <input
                    type="email"
                    value={editForm.email}
                    onChange={(e) =>
                      setEditForm((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                    className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                    placeholder=" "
                  />
                  <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                    peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                    Email
                  </label>
                </div>

                <div className="relative">
                  <input
                    type="text"
                    value={editForm.city}
                    onChange={(e) =>
                      setEditForm((prev) => ({
                        ...prev,
                        city: e.target.value,
                      }))
                    }
                    className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                    placeholder=" "
                  />
                  <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                    peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                    City
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                  <input
                    type="text"
                    value={editForm.firm_name}
                    onChange={(e) =>
                      setEditForm((prev) => ({
                        ...prev,
                        firm_name: e.target.value,
                      }))
                    }
                    className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                    placeholder=" "
                  />
                  <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                    peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                    Firm Name
                  </label>
                </div>

                <div className="relative">
                  <select
                    value={editForm.customer_type || ""}
                    onChange={(e) =>
                      setEditForm((prev) => ({
                        ...prev,
                        customer_type: e.target.value,
                      }))
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-amber-500 bg-white"
                  >
                    <option value="">Select Customer Type</option>
                    {customerTypes.map((ct) => (
                      <option key={ct.id} value={ct.id}>
                        {ct.name}
                      </option>
                    ))}
                  </select>
                  <label className="block text-xs text-gray-500 mt-1">
                    Customer Type
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-4">
                <div className="relative">
                  <textarea
                    rows={3}
                    value={editForm.address}
                    onChange={(e) =>
                      setEditForm((prev) => ({
                        ...prev,
                        address: e.target.value,
                      }))
                    }
                    className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500 resize-y"
                    placeholder=" "
                  />
                  <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                    peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                    Address
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                  <input
                    type="text"
                    value={editForm.customer_code}
                    onChange={(e) =>
                      setEditForm((prev) => ({
                        ...prev,
                        customer_code: e.target.value,
                      }))
                    }
                    className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                    placeholder=" "
                  />
                  <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                    peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                    Customer Code
                  </label>
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-4 pt-3 border-t border-gray-200">
                <button
                  type="button"
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingCustomer(null);
                  }}
                  className="bg-white border-2 border-red-500 text-red-600 py-2 px-4 rounded-lg hover:bg-red-50 font-semibold text-sm transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-gradient-to-r from-amber-500 to-amber-600 text-white py-2 px-4 rounded-lg hover:from-amber-600 hover:to-amber-700 font-semibold text-sm transition-all duration-200"
                >
                  Save Changes
                </button>
              </div>

            </form>
          </div>
        </div>
      )} */}

      {/* Edit Customer Modal - using CreateCustomer.jsx UI */}

      {/* Edit Customer Modal - using CreateCustomer.jsx UI */}
      {isDealer && showEditModal && editingCustomer && (
        <LoadScriptNext
          googleMapsApiKey="AIzaSyBjwQjSQoYFe5OzJxbhnodl-usXAt6AH8g"
          libraries={["places"]}
        >
          <div className="fixed inset-0 z-50 bg-black/40 px-2 py-2 overflow-y-auto flex items-start justify-center pt-2">
            <div className="bg-white rounded-xl shadow-2xl border-2 border-amber-500 w-full max-w-3xl p-4 relative">
              {/* Close Button */}
              <button
                onClick={() => {
                  setShowEditModal(false);
                  setEditingCustomer(null);
                }}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <h2 className="text-xl font-bold bg-gradient-to-r from-amber-600 to-amber-500 bg-clip-text text-transparent mb-4">
                Edit Customer
              </h2>

              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (!editForm.name.trim()) {
                    alert("Name is required");
                    return;
                  }
                  if (
                    editForm.mobile &&
                    (!/^\d{10}$/.test(editForm.mobile) ||
                      !/^[6-9]/.test(editForm.mobile))
                  ) {
                    alert("Please enter a valid 10-digit mobile number");
                    return;
                  }

                  if (editForm.email) {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(editForm.email)) {
                      alert("Please enter a valid email address");
                      return;
                    }
                  }

                  const originalCode = editingCustomer.customer_code || "";
                  const newCode = (editForm.customer_code || "").trim();
                  if (newCode && newCode !== originalCode) {
                    const confirm1 = window.confirm(
                      "You are changing the Customer Code. This may affect reports and existing references.\nAre you sure you want to change it?",
                    );
                    if (!confirm1) return;
                    const confirm2 = window.confirm(
                      `Confirm updating Customer Code from "${originalCode}" to "${newCode}"?`,
                    );
                    if (!confirm2) return;
                  }

                  const payload = {
                    customer_id: editingCustomer.customer_id,
                    name: editForm.name.trim(),
                    mobile: editForm.mobile.trim(),
                    email: editForm.email.trim(),
                    city: editForm.city.trim(),
                    state: editForm.state.trim(),
                    firm_name: editForm.firm_name.trim(),
                    address: editForm.address.trim(),
                    customer_type: editForm.customer_type || undefined,
                    customer_code: editForm.customer_code.trim(),
                    customer_grade: editForm.customer_grade || "undefined",
                  };
                  const result = await dispatch(
                    updateCustomer(payload, userInfo.access_token),
                  );
                  if (result.success) {
                    setShowEditModal(false);
                    setEditingCustomer(null);
                    dispatch(fetchSalesmanCustomerList(userInfo.access_token));
                  } else {
                    // const msg =
                    //   result.error?.message ||
                    //   result.error?.detail ||
                    //   "Failed to update customer";
                    // alert(msg);
                  }
                }}
                className="space-y-3"
              >
                {/* Step 1: Basic Information */}
                <div className="bg-gradient-to-br from-amber-50/30 to-white border-2 border-amber-200 rounded-lg p-3">
                  <h3 className="text-sm font-semibold text-gray-950 mb-3 flex items-center gap-2">
                    <span className="text-lg">👤</span>
                    Basic Information
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {/* Name */}
                    <div className="relative">
                      <input
                        type="text"
                        value={editForm.name}
                        onChange={(e) =>
                          setEditForm((prev) => ({
                            ...prev,
                            name: e.target.value,
                          }))
                        }
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                        placeholder=" "
                        required
                      />
                      <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                        Name <span className="text-red-500">*</span>
                      </label>
                    </div>

                    {/* Firm Name */}
                    <div className="relative">
                      <input
                        type="text"
                        value={editForm.firm_name}
                        onChange={(e) =>
                          setEditForm((prev) => ({
                            ...prev,
                            firm_name: e.target.value,
                          }))
                        }
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                        placeholder=" "
                      />
                      <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                        Firm Name
                      </label>
                    </div>

                    {/* Customer Type */}
                    <div className="relative">
                      <select
                        value={editForm.customer_type || ""}
                        onChange={(e) =>
                          setEditForm((prev) => ({
                            ...prev,
                            customer_type: e.target.value,
                          }))
                        }
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-amber-500 bg-white"
                      >
                        <option value="">Select Customer Type</option>
                        {customerTypes.map((ct) => (
                          <option key={ct.id} value={ct.id}>
                            {ct.name}
                          </option>
                        ))}
                      </select>
                      <label className="block text-xs text-gray-500 mt-1">
                        Customer Type <span className="text-red-500">*</span>
                      </label>
                    </div>

                    {/* Customer Grade */}
                    {/* Customer Grade */}
                    <div className="relative">
                      <select
                        value={editForm.customer_grade || ""}
                        onChange={(e) =>
                          setEditForm((prev) => ({
                            ...prev,
                            customer_grade: e.target.value,
                          }))
                        }
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-amber-500 bg-white"
                        required
                      >
                        <option value="">Select Grade</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                      </select>
                      <label className="block text-xs text-gray-500 mt-1">
                        Customer Grade <span className="text-red-500">*</span>
                      </label>
                    </div>

                    {/* Customer Code */}
                    <div className="relative">
                      <input
                        type="text"
                        value={editForm.customer_code}
                        onChange={(e) =>
                          setEditForm((prev) => ({
                            ...prev,
                            customer_code: e.target.value,
                          }))
                        }
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                        placeholder=" "
                      />
                      <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                        Customer Code
                      </label>
                    </div>
                  </div>
                </div>

                {/* Step 2: Contact Information */}
                <div className="bg-gradient-to-br from-blue-50/30 to-white border-2 border-blue-200 rounded-lg p-3">
                  <h3 className="text-sm font-semibold text-gray-950 mb-3 flex items-center gap-2">
                    <span className="text-lg">📞</span>
                    Contact Information
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {/* Mobile */}
                    <div className="relative">
                      <input
                        type="text"
                        value={editForm.mobile}
                        onChange={(e) => {
                          const cleaned = e.target.value.replace(/\D/g, "");
                          if (cleaned === "" || cleaned.length <= 10) {
                            setEditForm((prev) => ({
                              ...prev,
                              mobile: cleaned,
                            }));
                          }
                        }}
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                        placeholder=" "
                        maxLength="10"
                      />
                      <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                        Mobile <span className="text-red-500">*</span>
                      </label>
                    </div>

                    {/* Email */}
                    <div className="relative">
                      <input
                        type="email"
                        value={editForm.email}
                        onChange={(e) =>
                          setEditForm((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }))
                        }
                        className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                        placeholder=" "
                      />
                      <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                        Email
                      </label>
                    </div>
                  </div>
                </div>

                {/* Step 3: Address Information */}
                <div className="bg-gradient-to-br from-green-50/30 to-white border-2 border-green-200 rounded-lg p-3">
                  <h3 className="text-sm font-semibold text-gray-950 mb-3 flex items-center gap-2">
                    <span className="text-lg">📍</span>
                    Address Information
                  </h3>

                  <div className="space-y-2">
                    {/* Address (Google Places Autocomplete) */}
                    <div className="relative">
                      <Autocomplete
                        onLoad={(ref) => (editAutocompleteRef.current = ref)}
                        onPlaceChanged={() => {
                          handleEditPlaceChanged();
                          setEditIsAddressFetched(true);
                        }}
                      >
                        <input
                          type="text"
                          value={editForm.address}
                          onChange={(e) => {
                            setEditForm((prev) => ({
                              ...prev,
                              address: e.target.value,
                            }));
                            setEditIsAddressFetched(false);
                          }}
                          className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500"
                          placeholder=" "
                        />
                      </Autocomplete>
                      <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                        Address <span className="text-red-500">*</span>
                      </label>
                      {editIsAddressFetched && (
                        <p className="mt-1 text-xs text-green-600 flex items-center gap-1">
                          <span>✓</span> Address details auto-filled
                        </p>
                      )}
                    </div>

                    {/* City and State */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      {/* State */}
                      <div className="relative">
                        <input
                          type="text"
                          value={editForm.state}
                          onChange={(e) =>
                            setEditForm((prev) => ({
                              ...prev,
                              state: e.target.value,
                            }))
                          }
                          disabled={
                            editIsAddressFetched ? editDisableState : true
                          }
                          className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                          placeholder=" "
                        />
                        <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                          State <span className="text-red-500">*</span>
                        </label>
                      </div>

                      {/* City */}
                      <div className="relative">
                        {editIsAddressFetched ? (
                          <>
                            <input
                              type="text"
                              value={editForm.city}
                              onChange={(e) =>
                                setEditForm((prev) => ({
                                  ...prev,
                                  city: e.target.value,
                                }))
                              }
                              disabled={editDisableCity}
                              className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-amber-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                              placeholder=" "
                            />
                            <label className="pointer-events-none absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-amber-500">
                              City <span className="text-red-500">*</span>
                            </label>
                          </>
                        ) : (
                          <div ref={editCityDropdownRef}>
                            <label className="block text-xs text-gray-500 mb-1">
                              City <span className="text-red-500">*</span>
                            </label>
                            <button
                              type="button"
                              disabled={citiesLoading}
                              onClick={() =>
                                setEditCityDropdownOpen((prev) => !prev)
                              }
                              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-left bg-white focus:outline-none focus:border-amber-500 disabled:bg-gray-100 disabled:cursor-not-allowed relative"
                            >
                              <span
                                className={
                                  editForm.city
                                    ? "text-gray-900"
                                    : "text-gray-400"
                                }
                              >
                                {citiesLoading
                                  ? "Loading..."
                                  : editForm.city || "Select City"}
                              </span>
                              <svg
                                className={`w-4 h-4 text-gray-400 absolute right-3 top-1/2 -translate-y-1/2 transition-transform ${
                                  editCityDropdownOpen ? "rotate-180" : ""
                                }`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                            </button>
                            {editCityDropdownOpen && !citiesLoading && (
                              <ul className="absolute z-20 mt-1 w-full max-h-48 overflow-y-auto bg-white border-2 border-gray-300 rounded-lg shadow-lg">
                                {karnatakaCities.map((city, idx) => {
                                  const cityName =
                                    typeof city === "string" ? city : city.name;
                                  return (
                                    <li
                                      key={idx}
                                      onClick={() => {
                                        setEditForm((prev) => ({
                                          ...prev,
                                          city: cityName,
                                        }));
                                        setEditCityDropdownOpen(false);
                                      }}
                                      className={`px-4 py-2 text-sm cursor-pointer hover:bg-amber-50 ${
                                        editForm.city === cityName
                                          ? "bg-amber-100 font-medium text-amber-700"
                                          : "text-gray-700"
                                      }`}
                                    >
                                      {cityName}
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end gap-2 mt-3 pt-2 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => {
                      setShowEditModal(false);
                      setEditingCustomer(null);
                    }}
                    className="bg-white border-2 border-red-500 text-red-600 py-2 px-4 rounded-lg hover:bg-red-50 font-semibold transition-all duration-200 shadow-sm hover:shadow-md"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-amber-500 to-amber-600 text-white py-2 px-4 rounded-lg hover:from-amber-600 hover:to-amber-700 font-semibold transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </LoadScriptNext>
      )}
    </DashboardLayout>
  );
};

export default CustomerList;
